import * as yup from "yup";
import {
  nameSchema,
  descriptionSchema,
  memberArraySchema2,
  noteSchema,
} from "./ValidationSchemas";

export const addFolderschema = yup.object({
  name: nameSchema,
  description: descriptionSchema,
});

export const sharefolderSchemaObj = yup.object({
  shareWith: memberArraySchema2,
  note: noteSchema,
});
